import { mapGetters } from 'vuex';

import { ioCompanyGroups } from '@/febos/servicios/api/empresas.api';

export default {
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  methods: {
    async findCodeGroup() {
      const userId = this.currentUser.id;
      const companyId = this.company.id;

      const response = await ioCompanyGroups({
        empresaId: companyId,
        filtros: `usuarioId:${userId}`
      });
      const userGroups = response.data.grupos;

      return userGroups.length ? userGroups[0].codigo : '';
    }
  }
};
